import { http } from "./httpClient";

/** All Brands = every connected Instagram account with its profile counts (official Meta values; null = not returned). */
export const brandsApi = {
  list: () => http.get("/brands/"),
  refresh: () => http.post("/brands/refresh/", {}),
};
